// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3ezOC","empty":"ModalGraph_empty__2u-NU"};